module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-item-warp"
  }, [_c('div', {
    staticClass: "scroll-warp"
  }, [_c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', {
      style: ({
        height: _vm.defaultHeight + 'px'
      })
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e50a16"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/select-area/item.vue
// module id = 265
// module chunks = 2 3 4 7 8 11 12 18 65 67